export default {
	SIGN: 'Sign',
	ITEMS_WITH_ZERO: 'Items with no count',
	COUNT_ZERO_REVIEW: 'Items with no count'
};